import { Injectable } from '@angular/core';
import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action, Store } from '@ngrx/store';

import { IApplicationState } from '../../stateManagement/states/applicationState';
import * as applicationActions from '../../stateManagement/actions/containers/application';

import * as commonTypes from '../../shared/types';

@Injectable()
export class NotificationEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IApplicationState>
  ) {}

  @Effect() showNotification$: Observable<Action> = this.actions$
    .ofType(applicationActions.ActionTypes.POP_NOTIFICATION)
    .map(action => action.payload)
    .map((toastr: commonTypes.IToastr) => new applicationActions.PopNotificationSuccessAction(toastr));
    
}


// WEBPACK FOOTER //
// ./src/app/shared/effects/notification.effect.ts